module.exports = __webpack_public_path__ + "static/eliza@small-aeb6a14332d720de5022d818470ab4e1.jpg";